import React from "react";
import {
	Typography,
	Button,
	Space,
	Avatar,
	Dropdown,
	Menu,
} from "@arco-design/web-react";
import { IconUser, IconPoweroff } from "@arco-design/web-react/icon";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { goSWApiDocument } from "../../utils/common";
import Logo from "../Logo";

const { Title } = Typography;

interface NavbarProps {
	className?: string;
	onLoginClick?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ className, onLoginClick }) => {
	const { isAuthenticated, user, logout } = useAuth();
	const history = useHistory();

	const handleLogout = () => {
		logout();
		history.push("/");
	};

	// 返回到首页
	const goHome = () => {
		history.push("/");
	};

	// 跳转控制台
	const goConsole = () => {
		history.push("/console");
	};

	const userMenu = (
		<Menu>
			<Menu.Item key="profile" disabled>
				<IconUser style={{ marginRight: 8 }} />
				{user?.username || user?.nickname || "用户"}
			</Menu.Item>
			<Menu.Item key="logout" onClick={handleLogout}>
				<IconPoweroff style={{ marginRight: 8 }} />
				退出登录
			</Menu.Item>
		</Menu>
	);

	return (
		<nav className={`navbar ${className || ""}`}>
			<div className="navbar-container">
				{/* Logo和品牌 */}
				<div className="navbar-brand" onClick={goHome}>
					<Logo width={70} height={24} className="navbar-logo" />
				</div>

				{/* 导航菜单 */}
				<Space size="large" className="navbar-nav">
					{isAuthenticated ? (
						<>
							<Button
								type="text"
								className="arco-btn-text"
								onClick={() => history.push("/interface-debug")}
							>
								API
							</Button>
							<Button type="text" className="arco-btn-text" onClick={goConsole}>
								控制台
							</Button>
							<Button
								type="text"
								className="arco-btn-text"
								onClick={goSWApiDocument}
							>
								文档 ↗
							</Button>
							{/* 用户头像和菜单 */}
							<Dropdown trigger="click" droplist={userMenu} position="bl">
								<Avatar size={36} className="navbar-avatar">
									{user?.username?.charAt(0)?.toUpperCase() ||
										user?.nickname?.charAt(0)?.toUpperCase() || <IconUser />}
								</Avatar>
							</Dropdown>
						</>
					) : (
						<>
							<Button
								type="primary"
								className="navbar-login-btn"
								onClick={onLoginClick}
							>
								登录
							</Button>
						</>
					)}
				</Space>
			</div>
		</nav>
	);
};

export default Navbar;
